import React, { useRef } from 'react';
import { TabPanel } from 'primereact/tabview';
import Pages from '../../../../config/Pages';
import Multipage from '../../../../core/components/Multipage';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import { isEmpty } from '../../../../core/utils/ValidForm';
import FormDadosGerais from '../../propostaIndicador/components/formDadosGerais/FormDadosGerais';
import FormDadosComplementares from '../../propostaIndicador/components/formDadosComplementares/FormDadosComplementares';
import FormSerieHistorica from '../../propostaIndicador/components/formSerieHistorica/FormSerieHistorica';
import indicadorService from '../../../../service/IndicadorService';

function MultipageIndicador({
    onSaveDadosGerais,
    onEnviar = () => {},
    className,
    idProposta,
    isView = false,
    disableButtonVoltar = false,
}) {
    const confirmRef = useRef(null);
    const confirmOkRef = useRef(null);
    const dadosGeraisRef = useRef(null);
    const multipageRef = useRef(null);

    return (
        <>
            <ConfirmDialog header="Informativo" isOk ref={confirmOkRef} />
            <ConfirmDialog ref={confirmRef} />
            <Multipage
                ref={multipageRef}
                initialData={{
                    confirmRef,
                    confirmOkRef,
                    idProposta,
                    multipageRef,
                    voltarUrl: Pages.sei.indicador.url.list,
                }}
                onBeforeChange={() => {
                    if (multipageRef.current?.activeTab === 0) {
                        multipageRef.current?.addDataToContext({
                            nmIndicador:
                                dadosGeraisRef.current?.formController?.initialValues?.nmIndicador,
                        });
                    }
                }}
                className={className}
            >
                <TabPanel header={Pages.sei.propostaIndicador.tabs.dadosGerais}>
                    <FormDadosGerais
                        ref={dadosGeraisRef}
                        disableButtonVoltar={disableButtonVoltar}
                        isView={isView}
                        onSave={(dados) => {
                            if (onSaveDadosGerais) {
                                onSaveDadosGerais(dados);
                            }
                        }}
                        onFind={indicadorService.getDadosGerais.bind(indicadorService)}
                    />
                </TabPanel>
                <TabPanel
                    header={Pages.sei.propostaIndicador.tabs.dadosComplementares}
                    disabled={isEmpty(idProposta)}
                >
                    <FormDadosComplementares
                        isView={isView}
                        disableButtonVoltar={disableButtonVoltar}
                        onFind={indicadorService.getDadosComplementares.bind(indicadorService)}
                    />
                </TabPanel>
                <TabPanel
                    header={Pages.sei.propostaIndicador.tabs.serieHistorica}
                    disabled={isEmpty(idProposta)}
                >
                    <FormSerieHistorica
                        isView={isView}
                        disableButtonVoltar={disableButtonVoltar}
                        onEnviar={(response) => onEnviar(response)}
                        onFind={indicadorService.getSerieHistorica.bind(indicadorService)}
                    />
                </TabPanel>
            </Multipage>
        </>
    );
}

export default MultipageIndicador;
